import { Popover } from "@mui/material";
import { ColumnApi, GridApi, } from "ag-grid-community";
import _, { set } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";
import { LoadPhoneNumbersGridData, LoadUsers } from "../../actions";
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import setToast from "../../helpers/toaster.helper";
import { PhoneNumberModel } from "../../models/phone-number.model";
import { ITransferLogModel, mapToTransferLogs } from "../../models/transfers-model";
import { UserModel } from "../../models/users.model";
import * as selector from '../../selectors/selectors';
import { PhoneNumberService } from "../../services/PhonenumberService";
import { UtilityService } from "../../services/UtilityService";
import { AppRoutes } from "../routes/route.path";
import { ToasterTexts, pageTitles } from "../shared/constants";
import FilterComponent from "../shared/filters/filter.component";
import { CustomFilterCategory } from "../shared/filters/filter.model";
import PageHeaderComponent from "../shared/page-header.component";
import { ToasterType } from "../shared/toaster/toaster.model";
import Log from "./transfer-logs.component";
import Transfer from "./transfer.component";
import { UserService } from "../../services/UserService";
import AutomateTransferComponent from "./automate-transfer.component";

interface IProps {
}

const TransferComponent: React.FC<IProps> = (props: IProps) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
	const Users: UserModel[] = useSelector(selector.users)
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const [anchorEl, setAnchorEl] = useState<Element | null>();
	const [gridApi, setGridApi] = useState<GridApi>(null)
	const [columnApi, setColumnApi] = useState<ColumnApi>(null)
	const [ShowFilters, setShowFilters] = useState<boolean>(false);
	const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false);
	const [data, setData] = useState([]);
	const [Logs, setLogs] = useState<ITransferLogModel[]>([]);
	const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
	const [appliedfilters, setappliedfilters] = useState<ITransferLogModel[]>([]);
	const [persistedFilters, setPersistedFilters] = useState<CustomFilterCategory[]>([]);
	const [selectedFilterOptions, setSelectedFilterOptions] = useState<number | null>();
	const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);

	//filters


	const initialFilterOptions = () => {
		const filterData: any[] = [
			{
				Id: 1,
				Title: "Credit Type",
				IsSelectedAll: false,
				Options: _(Logs)
					.map(row => ({
						Key: "CreditType",
						Id: row.CreditType,
						Label: row.CreditType,
						Value: row.CreditType,
						IsSelected: false
					}))
					.uniqBy('Label')
					.value()
			},

		]
		setFilterOptions(filterData)
	}

	const handleApplyFilters = (filters: CustomFilterCategory[]) => {
		setFilterOptions(filters);
		const { result } = UtilityService.getFilterTypes(filters);
		setSelectedFilterTypes(result)
		// const { filteredData, selectedFilters, selectedFilterTypes } = UtilityService.applyFilters(Logs, filters);
		// setSelectedFilterOptions(selectedFilters)
		// setappliedfilters(filteredData);
		// setPersistedFilters(filters);
		// setSelectedFilterTypes(selectedFilterTypes)

		// if (filteredData.length === 0) {
		// 	setappliedfilters([]);
		// }
	};

	useEffect(() => {
		initialFilterOptions()
	}, [Logs, appliedfilters])
	//filters

	const searchLogs = (e: any) => {
		gridApi.setQuickFilter(e.target.value)
	}

	const onGridReady = (params) => {
		setGridApi(params.api);
		setColumnApi(params.columnApi)
	}

	const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (IsMobileDevice) {
			setShowFilters(true)
		}
		else {
			setAnchorEl(event.currentTarget)
		}
	}

	const handleCloseFilter = () => {
		setAnchorEl(null);
		setShowFilterOptions(false);
		setShowFilters(false)
	}

	useEffect(() => {
		LoadPhoneNumbersGridData(dispatch);
		LoadUsers(dispatch);
		refreshData();
	}, [])

	useEffect(() => {
		if (location.pathname === AppRoutes.TRANSFER_LOGS) {
			refreshData()
		}
		return setRefreshHandler
	}, [location.pathname])

	useEffect(() => {
		setHeaderTitle(pageTitles.TRANSFER_CREDITS);
		if (location.pathname === AppRoutes.TRANSFER_LOGS) {
			setRefreshHandler(refreshData)
		}
	}, [gridApi, columnApi])

	const refreshData = async () => {
		PhoneNumberService.getCreditTransferHistory().then((res: any) => {
			setData(res.data);
		}).catch(error => {
			setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
		})

		if (!!columnApi) {
			columnApi.resetColumnState()
		}

		if (!!gridApi) {
			gridApi.refreshCells({ force: true })
		}
	}

	useEffect(() => {
		setLogs(data.map((x: any) => mapToTransferLogs(x, PhoneNumbers, Users)));
	}, [data, PhoneNumbers, Users])

	const getGridTitle = () => {
		return !(location.pathname === AppRoutes.TRANSFER_LOGS) ? "" : Logs?.length === 1 ? "1 Log" : Logs?.length + " " + "Logs"
	}

	return (
		<>
			{
				ShowFilters && IsMobileDevice ?
					<FilterComponent
						Filters={filterOptions}
						HandleApplyFilters={handleApplyFilters}
						OnClose={handleCloseFilter}
					/>
					:
					<div>
						<PageHeaderComponent
							GridTitle={""}
							// Count={location.pathname === AppRoutes.TRANSFER_LOGS ? Logs.length : undefined}
							HandleFilter={(e) => handleClickFilter(e)}
							ShowFilterIcon={location.pathname === AppRoutes.TRANSFER_LOGS}
							IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
							onSearch={(e) => searchLogs(e)}
							HideSearch={location.pathname !== AppRoutes.TRANSFER_LOGS}
							PlaceHolder={"Find in logs ..."}
							ShowMultiActionButtons={false}
						/>
						<div className="d-flex">
							<Link className={`${!IsMobileDevice ? "ml-2 w-25" : "ml-1 w-22"}  t-align-center py-1 c-pointer h4-regular ${location.pathname === AppRoutes.TRANSFERS ? 'color-conv-hist-menu  h4-semibold' : 'color-conv-section-inactive'}`} to={AppRoutes.TRANSFERS} >{IsMobileDevice ? pageTitles.MANUAL_TRANSFER : pageTitles.TRANSFERS}</Link>
							{UserService.hasOrgAdminRole() && <Link className={`${!IsMobileDevice ? "w-25" : "w-23"}  t-align-center py-1 c-pointer h4-regular ${location.pathname === AppRoutes.AUTOMATE_TRANSFER ? 'color-conv-hist-menu h4-semibold' : 'color-conv-section-inactive'}`} to={AppRoutes.AUTOMATE_TRANSFER}>{IsMobileDevice ? pageTitles.AUTO_TRANSFER : pageTitles.AUTOMATE_TRANSFER}</Link>}
							<Link className={`${!IsMobileDevice ? "w-14" : "w-15 mr-1"}  t-align-center py-1 c-pointer h4-regular ${location.pathname === AppRoutes.TRANSFER_LOGS ? 'color-conv-hist-menu h4-semibold' : 'color-conv-section-inactive'}`} to={AppRoutes.TRANSFER_LOGS}>{pageTitles.LOGS}</Link>
						</div>
						{/* <div
							className={`show-conversation-animation show-conversation-border show-conversation-height bg-color-primary-light 
								${location.pathname === AppRoutes.TRANSFERS
									? (!IsMobileDevice ? "ml-2 w-25" : "ml-2 w-16")
									: location.pathname === AppRoutes.AUTOMATE_TRANSFER
										? (!IsMobileDevice ? "ml-29 w-21" : "ml-19 w-16")
										: location.pathname === AppRoutes.TRANSFER_LOGS
											? (!IsMobileDevice ? "ml-54 w-11" : "ml-37 w-10")
											: ""
								}`}>
						</div> */}
						{!IsMobileDevice &&
							<div className={`show-conversation-animation show-conversation-border show-conversation-height bg-color-primary-light ${location.pathname === AppRoutes.TRANSFERS ? "ml-2 w-25" :
								location.pathname === AppRoutes.AUTOMATE_TRANSFER ? "ml-29 w-21" : (UserService.hasUserRole() ? "ml-29 w-11" : "ml-54 w-11")}`}>
							</div>}
						{
							location.pathname === AppRoutes.TRANSFERS ? <div><Transfer /></div> :
								(UserService.hasOrgAdminRole() && location.pathname === AppRoutes.AUTOMATE_TRANSFER) ? <div><AutomateTransferComponent /></div> :
									<Log
										onGridReady={onGridReady}
										logsData={!!appliedfilters.length && !!selectedFilterOptions ? appliedfilters : Logs}
										refreshData={refreshData}
										filterOptions={filterOptions}
										IsFilterPresent={true}
										gridApi={gridApi}
										selectedFilterTypes={selectedFilterTypes}
									/>
						}
						{/* <Route
								onGridReady={onGridReady}
								logsData={!!appliedfilters.length && !!selectedFilterOptions ? appliedfilters : Logs}
								refreshData={refreshData}
								filterOptions={filterOptions}
								IsFilterPresent={true}
								gridApi={gridApi}
								selectedFilterTypes={selectedFilterTypes}
							/>} />
						</Routes>

							/> */}
						{Boolean(anchorEl) && !IsMobileDevice &&
							<Popover
								open={Boolean(anchorEl)}
								anchorEl={anchorEl}
								onClose={handleCloseFilter}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'left',
								}}
								transformOrigin={{
									vertical: 'top',
									horizontal: 'left',
								}}
								classes={{ paper: `min-w-40 ${ShowFilterOptions ? "min-h-40" : ""}` }}
							>
								<FilterComponent
									Filters={filterOptions}
									HandleApplyFilters={handleApplyFilters}
									OnClose={handleCloseFilter}
								/>
							</Popover>
						}
					</div>
			}
		</>
	)
}
export default TransferComponent